import { useFaroColorScheme } from "@flat-ui";
import { useThemeMode } from "@hooks/use-theme-mode";
import { PropsWithChildren, useLayoutEffect } from "react";

/**
 * Applies the chosen colour scheme to flat-ui's theme.
 *
 * This has to be a child of the theme provider: `useFaroColorScheme` reads the colour-scheme context
 * that the provider creates, and called above it the hook falls back to a `setMode` that does nothing.
 *
 * "system" is handed over unresolved, so that the theme follows the OS colour scheme itself.
 */
export function ColorSchemeSync({
  children,
}: PropsWithChildren): React.JSX.Element {
  const mode = useThemeMode();
  const { setMode } = useFaroColorScheme();

  // A layout effect, so that the scheme is set before the browser paints and no light frame shows
  useLayoutEffect(() => {
    setMode(mode);
  }, [mode, setMode]);

  // eslint-disable-next-line react/jsx-no-useless-fragment -- a provider-less pass-through
  return <>{children}</>;
}
